export interface OrdersAccessModel {
  // General access section.
  canReadOrders: boolean;
  canReadOrdersById: boolean;
  canReadEquipmentOfOrder: boolean;
  canChangeOrderStatus: boolean;
  canWriteOrders: boolean;
  canReadReceiptOfOrder: boolean;
  canWriteReceiptOfOrder: boolean;
  canSaveForce: boolean;
  canReadDebts: boolean;
  canWriteDebts: boolean;
}


export const ORDERS_ACCESS_DEFAULT: OrdersAccessModel = {
  canReadOrders: false,
  canReadOrdersById: false,
  canReadEquipmentOfOrder: false,
  canChangeOrderStatus: false,
  canWriteOrders: false,
  canReadReceiptOfOrder: false,
  canWriteReceiptOfOrder: false,
  canSaveForce: false,
  canReadDebts: false,
  canWriteDebts: false
};
